import { createAction, EntityId, PayloadAction } from "@reduxjs/toolkit";
import { Notification, notificationsActions } from "../features/notifications";
import { delay, put, takeEvery } from "redux-saga/effects";
import { v4 as uuid } from "uuid";

interface DeleteNotificationPayload {
  id: EntityId;
  delayInMs?: number;
}
export const deleteNotification = createAction<DeleteNotificationPayload>(
  "saga/notifications/deleteNotification"
);

function* handleDeleteNotification(
  action: PayloadAction<DeleteNotificationPayload>
) {
  yield delay(action.payload.delayInMs ?? 0);
  yield put(notificationsActions.removeNotification(action.payload.id));
}

export const pushNotification = createAction<
  Omit<Notification, "id" | "dateCreated">
>("saga/notifications/pushNotification");
function* handlePushNotification(
  action: PayloadAction<Omit<Notification, "id" | "dateCreated">>
) {
  // console.log("saga run pushing notif", action);
  const id = uuid();
  yield put(notificationsActions.postNotificaton({ ...action.payload, id }));

  // remove the notification after 5 seconds
  yield put(deleteNotification({ id, delayInMs: 5000 }));
}

export function* processNotifications() {
  yield takeEvery(
    "saga/notifications/pushNotification",
    handlePushNotification
  );
  yield takeEvery(
    "saga/notifications/deleteNotification",
    handleDeleteNotification
  );
}
